export const transactionHistoryTypeConstants = [
  { name: "Credit", value: "credit" },
  { name: "Debit", value: "debit" },
];
